import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ErrorHandlingService} from '../common/error-handling.service';
import {Observable} from 'rxjs';
import {CommonResponse, processNormal} from '../common/response.model';
import {environment} from '../../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {UserValidation} from './user-validation.model';
import {UserToken} from './user.model';

@Injectable({
  providedIn: 'root'
})
export class UserValidationsService {

  constructor(private http: HttpClient, private errorHandling: ErrorHandlingService) {
  }

  getSetting(): Observable<UserValidation> {

    return this.http.get<CommonResponse<UserValidation>>(
      environment.apiUrl + 'user/validation/settings',
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }

  validateTokens(tokens: string[]): Observable<UserToken[]> {

    return this.http.post<CommonResponse<UserToken[]>>(
      environment.apiUrl + 'user/validation/valid-token',
      {
        tokens
      }
    ).pipe(
      map(resp => processNormal(resp)),
      catchError(this.errorHandling.handleErrors)
    );
  }
}
